document.querySelectorAll('form.formular.handler').forEach(form => {
	form.addEventListener('submit', e => {
		e.preventDefault();

		const trigger = form.querySelector('.submit');
		trigger.innerHTML = trigger.dataset.sending;

		form.querySelectorAll('.hint').forEach(hint => hint.remove());

		const data = new FormData(form);
		data.append('handle','form');
		data.append('subject',trigger.dataset.subject);
		data.append('receivers',trigger.dataset.receivers);

		fetch('./', {
			method: 'POST',
			body: data
		})
		.then(response => response.text())
		.then(reply => {
			if (reply == 'success') {
				trigger.style.display = 'none';
				form.insertAdjacentHTML('beforeend','<div class="hint success">'+trigger.dataset.success+'</div>');
			} else {
				trigger.innerHTML = trigger.dataset.label;
				form.insertAdjacentHTML('beforeend','<div class="hint error">'+trigger.dataset.error+'</div>');
				console.log(reply);
			}
		});
	});
});
